import { Target, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

interface ProtocolProgressCardProps {
  daysDone: number;
  totalDays: number;
  currentPhase: number;
  nextMilestone: number;
  resetCompleted?: boolean;
}

export const ProtocolProgressCard = ({ daysDone, totalDays, currentPhase, nextMilestone, resetCompleted = true }: ProtocolProgressCardProps) => {
  const adherence = Math.round((daysDone / totalDays) * 100);

  return (
    <div className="bg-card border rounded-3xl p-5 shadow-soft">
      {!resetCompleted && (
        <div className="mb-4 bg-wellness-peach/10 border border-wellness-peach/20 rounded-xl p-3 text-wellness-peach-dark text-[10px] font-bold uppercase flex items-center gap-2">
          <span className="animate-pulse">⚠️</span> Bloqueado: Completa el Reset de 3 días
        </div>
      )}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-primary/10 text-primary flex items-center justify-center">
            <Target className="h-4 w-4" />
          </div>
          <div>
            <h3 className="text-sm font-bold">Protocolo de 21 Días</h3>
            <p className="text-[10px] text-muted-foreground uppercase font-semibold">Fase {currentPhase}</p>
          </div>
        </div>
        <div className="text-right">
          <span className="text-lg font-bold text-primary block leading-none">{adherence}%</span>
        </div>
      </div>

      <div className="flex items-center gap-3 mb-4">
        <div className="flex-1 h-2.5 bg-secondary rounded-full overflow-hidden">
          <div 
            className="h-full gradient-primary rounded-full transition-all duration-1000 ease-out" 
            style={{ width: `${adherence}%` }} 
          />
        </div>
        <span className="text-xs font-bold text-muted-foreground">{daysDone}/{totalDays}</span>
      </div>

      <div className="bg-secondary rounded-xl p-3 flex items-center justify-between mb-4">
        <p className="text-xs text-muted-foreground">
          Próximo hito: <strong className="text-foreground">Día {nextMilestone}</strong>
        </p>
      </div>

      <Link 
        to="/app/protocolo" 
        className="w-full flex items-center justify-center gap-2 py-3 rounded-xl border border-primary/20 bg-primary/5 text-primary text-sm font-semibold hover:bg-primary/10 transition-colors"
      >
        Continuar protocolo <ChevronRight className="h-4 w-4" />
      </Link>
    </div>
  );
};
